import React from 'react'
import { EventTargetWithClassName } from "../Models/system"

function clickWasOnAccordionHeader(event: MouseEvent):  EventTargetWithClassName | undefined {
	let accordionCardElement: EventTargetWithClassName | undefined  = undefined
	let accordionHeaderElement: EventTargetWithClassName | undefined  = undefined

	const pathArray = event.composedPath() as Array<EventTargetWithClassName>

	if (pathArray) {
		pathArray.some(e => { 
			if (e.className == CLASS_NAMES.COLLAPSED_CARD || e.className == CLASS_NAMES.EXPANDED_CARD) {
				accordionCardElement = e
			}
			else if (e.className == CLASS_NAMES.CARD_HEADER) {
				accordionHeaderElement = e
			}
			return accordionCardElement && accordionHeaderElement
		})
	}

	if (accordionCardElement && accordionHeaderElement) {
		return accordionCardElement
	}
}

const CLASS_NAMES = {
	COLLAPSED_CARD: 'collapsed card', 
	EXPANDED_CARD: 'expanded card', 
	CARD_HEADER: 'card-header'
}

export function useCardAccordion() {

	function globalClickListener(event: MouseEvent) {
		const accordionCard = clickWasOnAccordionHeader(event)

		if (accordionCard) {
			// toggle expanded/collapsed class if click detected on accordion card header
			if (accordionCard.className == CLASS_NAMES.COLLAPSED_CARD)
				accordionCard.className = CLASS_NAMES.EXPANDED_CARD
			else if (accordionCard.className == CLASS_NAMES.EXPANDED_CARD)
				accordionCard.className = CLASS_NAMES.COLLAPSED_CARD
		}
	}

	React.useEffect(() => {
		// register listener
		document.addEventListener('click', globalClickListener)

		// cleanup function deregisters it 
		return () => {
			document.removeEventListener('click', globalClickListener)
		}
	}, [])
}